import { CookieManager } from '@/utils/cookieManager';

let csrfToken: string | null = null;

export async function initCsrf(): Promise<void> {
  const res = await fetch('/api/v1/get-csrf-token/', { credentials: 'same-origin' });
  csrfToken = res.headers.get('X-CSRFToken');
}

export function getCsrfToken(): string | null {
  return csrfToken ?? CookieManager.get('csrftoken');
}

export async function ensureCsrfHeader(headers: Record<string, string> = {}): Promise<Record<string, string>> {
  if (!csrfToken) {
    await initCsrf();
  }
  const token = getCsrfToken();
  if (!token) {
    throw new Error('Failed to obtain CSRF token');
  }
  return { ...headers, 'X-CSRFToken': token };
}
